const PaymentStatusOptions = [
  {
    label: 'Paid',
    value: 'PAID',
    color: 'success-lightest'
  },
  {
    label: 'Unpaid',
    value: 'UNPAID',
    color: 'danger-lightest'
  },
  {
    label: 'Partially Paid',
    value: 'PARTIALLY_PAID',
    color: 'warning-lightest'
  }
]

export default PaymentStatusOptions
